<template>
  <Layout>
    <Header>
      <Row justify="space-between" align="middle">
        <Col>
          <img src="../assets/images/logo-duolian2.png" class="header-logo" />
        </Col>
        <Col>
          <img src="../assets/images/duolianyun.svg" class="duolianyun" />
          <a
            href="https://www.dolinkhub.com/#/"
            target="_blank"
            class="duolian-link"
            >多链云</a
          >
          <Dropdown>
            <div>
              <img
                src="../assets/images/duolian-avator.svg"
                class="duolian-avator"
              />
              <span class="username">{{ userInfo.name }}</span>
            </div>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="handleUpdatePwd"
                >修改密码</DropdownItem
              >
              <DropdownItem divided @click.native="doExit">退出</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
    </Header>
    <Layout>
      <Sider hide-trigger :width="220">
        <section class="sider-content">
          <div
            @click="handleLocation(item)"
            :class="{
              'sider-cell': true,
              active: $route.meta.title === item.name
            }"
            v-for="item in siderList"
            :key="item.iconSvg"
          >
            <img
              class="icon-svg"
              :src="
                require(`../assets/images/portal/${item.iconSvg}-select.svg`)
              "
              v-if="$route.meta.title === item.name"
            />
            <img
              class="icon-svg"
              :src="require(`../assets/images/portal/${item.iconSvg}.svg`)"
              v-else
            />
            <span>{{ item.name }}</span>
          </div>
        </section>
      </Sider>
      <Content class="relative">
        <router-view />
      </Content>
    </Layout>
    <!-- 修改密码 -->
    <Modal
      :title="$t('loginPage.xgmm')"
      class-name="modal-container"
      v-model="pwdModalShow"
      width="450"
    >
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="120"
        style="width: 80%"
      >
        <FormItem :label="$t('loginPage.ymm')" prop="oldPassword">
          <Input
            v-model="formValidate.oldPassword"
            :placeholder="$t('loginPage.ymm')"
            type="password"
          ></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.xmm')" prop="password">
          <Input
            v-model="formValidate.password"
            :placeholder="$t('loginPage.xmm')"
            type="password"
          ></Input>
        </FormItem>
        <FormItem :label="$t('loginPage.qrxmm')" prop="newPassword">
          <Input
            v-model="formValidate.newPassword"
            :placeholder="$t('loginPage.qrxmm')"
            type="password"
          ></Input>
        </FormItem>
      </Form>
      <!-- <p style="padding: 0 24px;">{{ $t('mmzs') }}</p> -->
      <div slot="footer" class="modal-footer">
        <Button class="button" @click=";(pwdModalShow = false), doResetForm">{{
          $t('qx')
        }}</Button>
        <Button class="button" type="primary" @click="doUpdatePwd">{{
          $t('qr')
        }}</Button>
      </div>
    </Modal>
  </Layout>
</template>

<script>
import { session, cookie, local } from '@/libs/location'
export default {
  name: 'mainIndex',
  data() {
    return {
      siderList: [
        {
          iconSvg: 'shouye',
          path: '/duolianHome',
          name: '首页'
        },
        {
          iconSvg: 'yunying',
          path: '/fulfillmentCenter',
          name: '运营中心'
        },
        {
          iconSvg: 'yanshi',
          path: '/previewEnv',
          name: '演示环境'
        },
        {
          iconSvg: 'kehu',
          path: '/clientEnv',
          name: '客户环境'
        },
        {
          iconSvg: 'lianjie',
          path: '/extraLink',
          name: '外部链接'
        },
        {
          iconSvg: 'ceshi',
          path: '/testEnv',
          name: '测试环境'
        },
        {
          iconSvg: 'kaifa',
          path: '/developEnv',
          name: '开发环境'
        }
      ],
      userInfo: {},
      // 修改密码
      pwdModalShow: false,
      formValidate: {
        oldPassword: null,
        password: null,
        newPassword: null
      },
      ruleValidate: {
        oldPassword: [
          {
            required: true,
            message: this.$t('loginPage.ymmbnwk'),
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('loginPage.mmbnwk'),
            trigger: 'blur'
          }
        ],
        newPassword: [
          {
            required: true,
            message: this.$t('loginPage.mmbnwk'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    // 查询用户基本信息
    this.$request.post('/sso/userAttr/findUserInfo').then((res) => {
      const { code, data } = res.data
      if (code === 'OK') {
        this.userInfo = data
        session.setItem('userInfo', JSON.stringify(data))
        if (this.userInfo.isSSOAdmin) {
          this.siderList = this.siderList.concat([
            {
              iconSvg: 'shezhi',
              path: '/portalManage',
              name: '门户管理'
            }
          ])
        }
      }
    })
  },
  methods: {
    handleLocation(item) {
      if (item.name !== '门户管理') {
        this.$router.push(item.path)
      } else {
        const token = session.parseJSON() || cookie.getCookie('token')
        // window.open(
        //   `http://192.168.31.74:8081/qc-sso/home?authorization=${token}`,
        //   'manage'
        // )
        window.open(
          `http://${window.location.host}/qc-sso/home?authorization=${token}`,
          'manage'
        )
        // window.open(`http://${window.location.host}/qc-sso/inform-page?authorization=${JSON.parse(session.getItem('token'))}&informId=${item.workItemId}`)
      }
    },
    doExit() {
      this.$request
        .post('/sso/login/logoutUser', { sessionId: this.token })
        .then((res) => {
          let { code } = res.data
          if (code === 'OK') {
            cookie.removeCookie('token')
            cookie.removeCookie('userInfo')
            session.remove('token')
            session.remove('userInfo')
            this.$router.push({ name: 'login' })
            local.removeItem('userName')
            local.removeItem('password')
            this.$Message.success('退出成功')
          }
        })
    },
    // 修改密码
    handleUpdatePwd() {
      this.pwdModalShow = true
    },
    // 取消修改密码
    doResetForm() {
      this.formValidate = {
        oldPassword: null,
        password: null,
        newPassword: null
      }
      this.$refs['formValidate'].resetFields()
    },
    // 确认修改密码
    doUpdatePwd() {
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}$/
          if (
            !reg.test(this.formValidate.password) ||
            /[\u4E00-\u9FA5]/g.test(this.formValidate.password)
          ) {
            this.$Message.warning(this.$t('loginPage.mmzswzmsztszf'))
          } else if (
            this.formValidate.oldPassword === this.formValidate.password
          ) {
            this.$Message.warning(this.$t('loginPage.xmmbnyjmmxt'))
          } else if (
            this.formValidate.password !== this.formValidate.newPassword
          ) {
            this.$Message.warning(this.$t('loginPage.mmbyz'))
          } else {
            let req = {
              userCode: this.userInfo.userName,
              password: this.formValidate.password,
              oldPassword: this.formValidate.oldPassword,
              sessionId: this.userInfo.sessionId
            }
            this.$request
              .post('/sso/login/modPasswordForFirst', req)
              .then((res) => {
                const { code } = res.data
                if (code === 'OK') {
                  this.doResetForm()
                  this.$Message.success(this.$t('czcg'))
                  this.pwdModalShow = false
                }
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.modal-container {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
  .ivu-modal-body {
    padding: 0;
    padding-top: 16px;
  }
  .modal-title {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }
  .modal-content {
    display: flex;
    // justify-content: center;
    // align-items: center;
    flex-wrap: wrap;
    max-height: 360px;
    min-height: 130px;
    overflow-y: auto;
    &-center {
      justify-content: center;
    }
    .items {
      flex: 0 0 20%;
      position: relative;
      box-sizing: border-box;
      padding: 12px;
      text-align: center;
      img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-bottom: 8px;
      }
      .name {
        text-align: center;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        height: 44px;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        // white-space: nowrap;
        &[active] {
          color: #c8291d;
        }
      }
      .icon-normal {
        width: 38px;
        height: 38px;
        margin: 22px;
      }
      .back-name {
        line-height: 22px;
        height: auto;
      }
      .bj-light {
        position: absolute;
        top: 22px;
        left: 20px;
        width: 64px;
        height: 64px;
        background: #c8291d;
        border-radius: 8px;
        opacity: 0.5;
      }
      .checked {
        position: absolute;
        right: 26%;
        top: 12px;
        border: 2px solid #ffffff;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #c8291d;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          color: #ffffff;
          font-size: 16px;
        }
      }
    }
    .skin-box {
      width: 64px;
      height: 64px;
      border-radius: 50%;
    }
  }
  .modal-footer {
    display: flex;
    justify-content: flex-end;
    padding: 0 8px;
    .button {
      padding: 0 24px;
    }
  }
}
.sider-content {
  padding: 10px 8px;
  color: #262626;
  .sider-cell {
    cursor: pointer;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 2px;
    background-color: #fff;
    padding: 0 14px;
    margin-bottom: 8px;
    .icon-svg {
      width: 14px;
      margin-right: 14px;
    }
    &.active {
      background-color: #f2f3f5;
      font-weight: 500;
      color: #326fff;
    }
  }
}
.duolianyun {
  width: 36px;
  height: 24px;
  vertical-align: middle;
  margin-right: 8px;
}
.duolian-link {
  text-decoration: none;
  color: #000000;
  // font-weight: 400;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.username {
  display: inline-block;
  margin-left: 8px;
  margin-right: 16px;
  color: #000000;
  text-align: center;
  // font-weight: 800;
}
.duolian-avator {
  width: 32px;
  vertical-align: middle;
  margin-left: 24px;
}
.header-logo {
  height: 60px;
  width: 220px;
}
.ivu-layout {
  height: 100vh;
}
.ivu-layout-content {
  padding: 16px;
  padding-bottom: 0;
}
</style>
